import { ColorModeState } from './reducer';

export const selectColorModeState = (state: any): ColorModeState =>
  state.colorMode;

export const selectColorMode = (state: any) => selectColorModeState(state).mode;

export const selectIsDarkMode = (state: any) =>
  selectColorMode(state) === 'dark';
